// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAze5I6fkROwW7SETtvvHmpW7K2kPJe7Jo",
    authDomain: "news-ddb2a.firebaseapp.com",
    projectId: "news-ddb2a",
    storageBucket: "news-ddb2a.appspot.com",
    messagingSenderId: "354871529841",
    appId: "1:354871529841:web:84f3b77f88e7bc812526d0",
    measurementId: "G-BX0RRPHD0D"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);